var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendarAbout(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.66699 16C2.66699 10.9717 2.66699 8.45757 4.22909 6.89547C5.79119 5.33337 8.30534 5.33337 13.3337 5.33337H18.667C23.6953 5.33337 26.2095 5.33337 27.7716 6.89547C29.3337 8.45757 29.3337 10.9717 29.3337 16V18.6667C29.3337 23.695 29.3337 26.2092 27.7716 27.7713C26.2095 29.3334 23.6953 29.3334 18.667 29.3334H13.3337C8.30534 29.3334 5.79119 29.3334 4.22909 27.7713C2.66699 26.2092 2.66699 23.695 2.66699 18.6667V16Z",
    stroke: "#DC143C",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33301 5.33337V3.33337",
    stroke: "#DC143C",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.667 5.33337V3.33337",
    stroke: "#DC143C",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33301 12H28.6663",
    stroke: "#DC143C",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9997 22.6667C23.9997 23.403 23.4027 24 22.6663 24C21.93 24 21.333 23.403 21.333 22.6667C21.333 21.9303 21.93 21.3333 22.6663 21.3333C23.4027 21.3333 23.9997 21.9303 23.9997 22.6667Z",
    fill: "#DC143C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9997 17.3333C23.9997 18.0697 23.4027 18.6667 22.6663 18.6667C21.93 18.6667 21.333 18.0697 21.333 17.3333C21.333 16.597 21.93 16 22.6663 16C23.4027 16 23.9997 16.597 23.9997 17.3333Z",
    fill: "#DC143C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3337 22.6667C17.3337 23.403 16.7367 24 16.0003 24C15.2639 24 14.667 23.403 14.667 22.6667C14.667 21.9303 15.2639 21.3333 16.0003 21.3333C16.7367 21.3333 17.3337 21.9303 17.3337 22.6667Z",
    fill: "#DC143C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3337 17.3333C17.3337 18.0697 16.7367 18.6667 16.0003 18.6667C15.2639 18.6667 14.667 18.0697 14.667 17.3333C14.667 16.597 15.2639 16 16.0003 16C16.7367 16 17.3337 16.597 17.3337 17.3333Z",
    fill: "#DC143C"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 22.6667C10.6667 23.403 10.0697 24 9.33333 24C8.59695 24 8 23.403 8 22.6667C8 21.9303 8.59695 21.3333 9.33333 21.3333C10.0697 21.3333 10.6667 21.9303 10.6667 22.6667Z",
    fill: "#DC143C"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 17.3333C10.6667 18.0697 10.0697 18.6667 9.33333 18.6667C8.59695 18.6667 8 18.0697 8 17.3333C8 16.597 8.59695 16 9.33333 16C10.0697 16 10.6667 16.597 10.6667 17.3333Z",
    fill: "#DC143C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarAbout);
export default __webpack_public_path__ + "static/media/calendar-about.f992470e6b8da63ab98905783c9ff205.svg";
export { ForwardRef as ReactComponent };